import { gql } from '@graphql/__generated__';

export const GET_VISIBILITY_REVIEWS_AGGREGATE = gql(/* GraphQL */ `
  query GetVisibilityReviewsAggregate($teamId: uuid!) {
    teams_by_pk(id: $teamId) {
      id
      teams_users {
        user {
          id
          reviews_aggregate(where: { completed: { _eq: true } }) {
            aggregate {
              count
              avg {
                rating
              }
            }
          }
        }
      }
    }
  }
`);

export const GET_VISIBILITY_REVIEWS = gql(/* GraphQL */ `
  query GetVisibilityReviews(
    $teamId: uuid!
    $limit: Int!
    $offset: Int!
    $orderBy: [reviews_order_by!]
  ) {
    reviews(
      where: {
        completed: { _eq: true }
        user: { teams_users: { team_id: { _eq: $teamId } } }
      }
      limit: $limit
      offset: $offset
      order_by: $orderBy
    ) {
      id
      ...VisibilityReview
    }
  }
`);

export const GET_VISIBILITY_REVIEWS_ROW_COUNT = gql(/* GraphQL */ `
  query GetVisibilityReviewsRowCount($teamId: uuid!) {
    reviews_aggregate(
      where: {
        completed: { _eq: true }
        user: { teams_users: { team_id: { _eq: $teamId } } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_REVIEW_INVITATION_TEMPLATE = gql(/* GraphQL */ `
  query GetReviewInvitationTemplate(
    $brokerId: uuid!
    $type: review_invitation_type_enum_enum!
    $language: String!
  ) {
    review_invitation_templates(
      where: {
        broker_id: { _eq: $brokerId }
        type: { _eq: $type }
        language: { _eq: $language }
      }
      limit: 1
    ) {
      id
      broker_id
      tenant_id
      type
      language
      message
      created_at
      updated_at
    }
  }
`);

export const UPSERT_REVIEW_INVITATION_TEMPLATE = gql(/* GraphQL */ `
  mutation UpsertReviewInvitationTemplate(
    $brokerId: uuid!
    $type: review_invitation_type_enum_enum!
    $language: String!
    $message: String!
  ) {
    insert_review_invitation_templates_one(
      object: {
        broker_id: $brokerId
        type: $type
        language: $language
        message: $message
      }
      on_conflict: {
        constraint: review_invitation_templates_broker_type_language_unique
        update_columns: [message]
      }
    ) {
      id
      broker_id
      tenant_id
      type
      language
      message
      created_at
      updated_at
    }
  }
`);

export const GET_REVIEWS_WIDGET_AGENTS = gql(/* GraphQL */ `
  query GetReviewsWidgetAgents(
    $teamId: uuid!
    $publishedAgentsWhere: teams_users_bool_exp!
  ) {
    teams_by_pk(id: $teamId) {
      id
      show_in_agency_pages
      teams_users(where: $publishedAgentsWhere) {
        user {
          id
          full_name
          combined_reviews_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`);
